import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref, onBeforeMount } from 'vue'
import { IPageLayout, getComputedPageLayout } from '@/helpers/api';
import { getIcon } from '@/helpers/api';
import ModalMessage from '@/globals/components/ModalMessage.vue';
import { modalController } from '@ionic/vue';


interface _1611 extends IPageLayout {
    labels: {
        title: string,
        lines: Array<string>,
        button: string,
    }
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PointRulesModal',
  setup(__props) {

const icon = ref<string>()
const layout = getComputedPageLayout<_1611>('1611')
onBeforeMount(async () => {
    icon.value = await getIcon("1611", 'icon')
})

function close(){
    return modalController.dismiss(null, 'cancel')
}


return (_ctx: any,_cache: any) => {
  return (_unref(layout))
    ? (_openBlock(), _createBlock(ModalMessage, {
        key: 0,
        icon: icon.value,
        title: _unref(layout).labels.title,
        description: _unref(layout).labels.lines,
        button: {textContent: _unref(layout).labels.button, danger: false},
        onButtonClick: close
      }, null, 8, ["icon", "title", "description", "button"]))
    : _createCommentVNode("", true)
}
}

})